<app-avatar
  [tooltip]="user?.name?.first + ' ' + user?.name?.last"
  (click)="openDetailInfo(user.id)"
  [Service]="Service"
  [id]="user.id"
  [class.avatar-online]="user.online"
  [type]="'private'"
  [avatar]="user.avatar"
  class="avatar mx-3 pointer"
></app-avatar>
